import React, { createClass, PropTypes } from 'react';
import getClassNames from 'classnames';
import { IconButton, RaisedButton, TextField } from 'material-ui';
import { findDOMNode } from 'react-dom';

const ConnectionsSearchBar = createClass({

  propTypes: {
    searchWithInput: PropTypes.func,
    searchBarHintText: PropTypes.string,
    className: PropTypes.string,
    defaultValue: PropTypes.string,
  },

  getInitialState() {
    return {
      open: true,
      input: this.props.defaultValue || '',
    };
  },

  onClick() {
    document.getElementById('searchBar').focus();
    this.setState({ open: !this.state.open }, () => {
      if (this.state.open) document.getElementById('searchBar').focus();
      else document.getElementById('searchBar').blur();
    });
  },

  preventTabAndEnter(event) {
    if (event.keyCode === 13) {
      this.props.searchWithInput(this.state.input);
    }
    if (event.which === 9) {
      event.preventDefault();
    }
  },

  searchContent(event) {
    this.setState({ input: event.target.value });
  },

  clearInput() {
    findDOMNode(this.refs.searchBar).value = '';
    this.props.searchWithInput('');
    this.setState({ input: '' });
  },

  render() {
    const classes = getClassNames('connections-search-input', this.props.className, {
      'is-closed': !this.state.open,
    });

    return (
      <div
        className={`connections-search-bar ${this.props.className}`}
        style={{ border: '1px solid #00bcd4', borderRadius: '2px', height: '37px', position: 'relative', justifyContent: 'space-between', backgroundColor: 'white', display: 'flex' }}
      >
        <TextField
          hintText={this.props.searchBarHintText}
          value={this.state.input}
          inputStyle={{ bottom: '2px' }}
          style={{ width: '85%', height: '35px', marginLeft: '4px' }}
          hintStyle={{ bottom: '6px', fontSize: '13px' }}
          onKeyDown={this.preventTabAndEnter}
          underlineShow={false}
          ref="searchBar"
          onChange={this.searchContent}
        />
        <IconButton
          iconClassName="tc-icon-close"
          iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' }}
          style={{ padding: '0', top: '-2px', height: '37px', display: this.state.input ? 'inline-block' : 'none' }}
          onTouchTap={() => this.setState({ input: '' }, () => this.props.searchWithInput(this.state.input))}
        />
        <RaisedButton
          label="Search"
          style={{ minWidth: '82px', width: '82px' }}
          secondary
          onTouchTap={() => this.props.searchWithInput(this.state.input)}
        />
      </div>
    );
  },
});

export default ConnectionsSearchBar;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/search-bar.jsx